import axios from "axios";

const GET_WINNING_VOUCHERS_URL = `${process.env.REACT_APP_API_URL}winning/filter`;

const getWinningVouchers = (query) => (
    axios.get(`${GET_WINNING_VOUCHERS_URL}?${query}`)
)

export {getWinningVouchers}